<template>



    <div class="modal is-active  has-modal-card margin: 0 auto "  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
              Genertate Report CSV from Used Items for LAB Automate
            </header>

            <section class="modal-card-body">
                <!--                  content-->
                <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
<!--                <b-field horizontal label="Date Params"-->
<!--                         :type="{ 'is-danger': hasErrorDate }"-->
<!--                         :message="{ 'please input date valid': hasErrorDate }" >-->
<!--                    <b-datepicker v-model="date_selected"-->
<!--                                  placeholder="Click to select..."-->
<!--                                  icon="calendar-today"-->
<!--                    >-->
<!--                    </b-datepicker>-->
<!--                </b-field>-->


<!--                <b-field horizontal label="Date Params"-->
<!--                         :type="{ 'is-danger': hasErrorDate }"-->
<!--                         :message="{ 'please input date valid': hasErrorDate }" >-->
<!--                    <b-datepicker v-model="date_selected"-->
<!--                                  placeholder="Click to select..."-->
<!--                                  icon="calendar-today"-->
<!--                    >-->
<!--                    </b-datepicker>-->
<!--                </b-field>-->


                <b-field label="Start date">
                    <b-datepicker
                            v-model="date_start"
                            placeholder="Type or select a date..."
                            icon="calendar-today"
                            editable>
                    </b-datepicker>
                </b-field>

                <b-field label="To date">
                    <b-datepicker
                            v-model="date_end"
                            placeholder="Type or select a date..."
                            icon="calendar-today"
                            editable>
                    </b-datepicker>
                </b-field>


                <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/>



            </section>
            <footer class="modal-card-foot" style="justify-content: space-between;">
                <b-button type="is-danger"
                          icon-right="close"
                          @click="close" >Cancel</b-button>


                <b-button type="is-success"
                          icon-left="share"  @click="genReport"
                          :disabled= "hasErrorDate">
                    Generate and Send
                </b-button>

            </footer>
        </div>
    </div>


</template>

<script>
    import axios from "axios";
    import {   getBaseURLforBackEnd  , getConfigAxios   } from '@/utils.js'
    import findDiffDate from "../../../mixins/methods/findDiffDate";
    import {DateTime} from "luxon";

    export default {
        name: "ReportB01",
        created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()
                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
        },
        mixins:[findDiffDate],
        props:{
            isComponentModalActive : Boolean
        },
        methods:{

            genReport(){

                if(this.date_start === null){
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: `pls select Start date`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return
                }


                if(this.date_end === null){
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: `pls select To date `,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return
                }


                const daysDiff = this.findDiffDate(this.date_start,this.date_end)
                if ( daysDiff>31)  {
                      // console.log(`ok ${daysDiff}`)
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: `pls select date request between 31 days  ( your select date between  ${daysDiff} days)`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return
                }


                if ( daysDiff<0)  {
                    // console.log(`ok ${daysDiff}`)
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: `pls select date request negative data  ( your select date between  ${daysDiff} days)`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return
                }


                // console.log(`ok ${daysDiff}`)
                // if ok



                const vm = this
                const datTo = {
                    "date_selected": [
                        DateTime.utc((new Date(this.date_start)).getFullYear(), (new Date(this.date_start)).getMonth()+1, (new Date(this.date_start)).getDate()).toISO() ,
                        DateTime.utc((new Date(this.date_end)).getFullYear(), (new Date(this.date_end)).getMonth()+1, (new Date(this.date_end)).getDate()).toISO()
                    ] ,
                }
                this.isFullScreenSearching = true
                axios.post(`${getBaseURLforBackEnd()}/api/reportb01`,datTo,getConfigAxios())
                    .then((response)=> {
                        vm.isFullScreenSearching = false
                        vm.$buefy.toast.open({
                            duration: 5000,
                            message: `${response.data.msg}`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })
                        vm.$emit('close')
                    })
                    .finally(()=>{
                        vm.isFullScreenSearching = false
                        vm.$buefy.toast.open({
                            duration: 2000,
                            message: `Successful save to cloud server`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })
                    })


            },
            close(){
                this.$emit('close')
            },

            loadCurrentDate() {
                const vm = this
                axios.get(`${getBaseURLforBackEnd()}/api/curdatetime`, getConfigAxios())
                    .then(response => {
                        // this.date_selected = [new Date( response.data.current_datetime) , new Date( response.data.current_datetime)]
                        this.date_start = new Date(response.data.current_datetime_iso)
                        this.date_end = new Date(response.data.current_datetime_iso)
                        // console.log(this.date_selected )
                        // console.log( new Date( Date.parse(response.data.current_datetime)) )
                        // console.log( new Date( Date.parse(response.data.current_datetime_iso)) )
                    })
                    .catch((error) => {
                        // console.log(error)
                        vm.$buefy.toast.open({
                            duration: 500,
                            message: `${error}`,
                            position: 'is-bottom',
                            type: 'is-warning'
                        })
                    })

            }

        },
        data(){
             return {
                 isFullScreenSearching : false,

                 hasErrorDate : false,
                 date_start : null ,
                 date_end : null ,
            }
        },

        watch:{
            isComponentModalActive :{
                immediate: true,
                handler: function (val) {
                     if(val){
                         this.loadCurrentDate()
                     }
                }
            }
        }

    }
</script>

<style scoped>

</style>